var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalyze(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.2099 23.89C28.5737 25.3945 27.5787 26.7202 26.3118 27.7513C25.0449 28.7824 23.5447 29.4874 21.9424 29.8048C20.34 30.1221 18.6843 30.0421 17.1201 29.5718C15.5558 29.1014 14.1305 28.2551 12.9689 27.1067C11.8073 25.9582 10.9447 24.5428 10.4565 22.9839C9.96837 21.4251 9.86948 19.7705 10.1685 18.1646C10.4675 16.5588 11.1554 15.0506 12.172 13.772C13.1885 12.4934 14.5028 11.4833 15.9999 10.83M29.9999 20C29.9999 18.6868 29.7413 17.3864 29.2387 16.1732C28.7362 14.9599 27.9996 13.8575 27.071 12.9289C26.1424 12.0003 25.04 11.2638 23.8267 10.7612C22.6135 10.2587 21.3131 10 19.9999 10V20H29.9999Z",
    stroke: "currentColor",
    strokeWidth: 1.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalyze);
export default __webpack_public_path__ + "static/media/analyze.fdc7cfd9bf50a9c9f3261fcf6ece73db.svg";
export { ForwardRef as ReactComponent };